import { Content } from '@angular/compiler/src/render3/r3_ast';
import { Component, OnInit, Input } from '@angular/core';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-collapse-iptv',
  templateUrl: './collapse-iptv.component.html',
  styleUrls: ['./collapse-iptv.component.sass']
})
export class CollapseIptvComponent implements OnInit {
  @Input() chanels;
  @Input() color;
  @Input() category;
  @Input() plan;

 constructor( private global: GlobalService) { }
  ngOnInit() {}
  updateExpand(index:number){
    if(this.global.validateSession()===true){
      let content:any=this.chanels;
      content[index].expand=!content[index].expand;
    }
  }
}
